import Typography from '@mui/material/Typography';
import { useMemo } from 'react';

import { LookUp } from '@work4all/models/lib/Classes/LookUp.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { LookupType } from '@work4all/models/lib/Enums/LookupType.enum';

import { Tooltip } from '../../tooltip/Tooltip';
import { ListEntityPicker } from '../components/list-entity-picker/ListEntityPicker';
import { IPickerProps } from '../types';

export type ILookUpProps<TMultiple extends boolean> = IPickerProps<
  LookUp,
  TMultiple
> & {
  lookupType: LookupType;
};

export function LookUpPicker<TMultiple extends boolean>(
  props: ILookUpProps<TMultiple>
) {
  const { data, lookupType, ...rest } = props;

  const allFields = useMemo(() => {
    return { ...LookUp_FIELDS, ...data };
  }, [data]);

  return (
    <ListEntityPicker
      entity={Entities.lookUp}
      data={allFields}
      filterBy={['name', 'number']}
      sortBy="name"
      {...rest}
      vars={{ type: lookupType }}
      renderItemContent={(LookUp) => (
        <Tooltip title={LookUp.name}>
          <Typography variant="body2" noWrap>
            {LookUp.name}
          </Typography>
        </Tooltip>
      )}
    />
  );
}

const LookUp_FIELDS: LookUp = {
  id: null,
  name: null,
  value: null,
};
